import type { AttachmentFileList } from 'owa-attachment-file-types';
import { lazyLogAttachOrShareDatapoint } from 'owa-attachment-filepicker';
import type { CreateAttachmentsProperties } from 'owa-attachment-well-data';
import { lazyInsertLinks } from 'owa-insert-link';
import getCurrentFromAddress from 'owa-mail-compose-actions/lib/utils/getFromAddressFromRecipientWell';
import type { ComposeViewState } from 'owa-mail-compose-store';
import type AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { getInsertLinksHost } from 'owa-mail-compose-view-shared/lib/utils/getInsertLinksHost';

export async function upsellAndInsertLinks(
    files: AttachmentFileList,
    viewState: ComposeViewState,
    properties: CreateAttachmentsProperties,
    dataProvider: AttachmentDataProviderType,
    targetWindow: Window
): Promise<void> {
    const logAttachOrShareDatapoint = await lazyLogAttachOrShareDatapoint.import();
    logAttachOrShareDatapoint({
        files: files,
        isInline: false,
        shouldShare: true,
        dataProviderType: dataProvider,
    });
    const insertLinks = await lazyInsertLinks.import();
    insertLinks(
        files,
        getInsertLinksHost(viewState),
        viewState,
        getCurrentFromAddress(viewState.toRecipientWell),
        targetWindow,
        viewState.linksContainerId,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (35,9): Argument of type 'null' is not assignable to parameter of type 'string | undefined'.
        // @ts-expect-error
        null /* selectionText*/,
        properties
    );
}
